import { createMachine } from "xstate";
import config from "./config";
import { useMachine } from "@xstate/react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

const context = createMachine(config.state);

const useInterstitialMachine = () => {
	const history = useHistory();
	// TODO: Replace all usage and make reusable hook
	const useQuery = () => new URLSearchParams(useLocation().search);
	const query = useQuery();

	const events = {
		...config.events,
		actions: {
			...config.events.actions,
			redirectToManager: () => {
				history.push("/customize/manager");
			},
			redirectToBuilder: () => {
				history.push("/customize/demo/create");
			},
		},
		guards: {
			isMockFail: (context, event) => query.get("mock") === "fail",
			isDefault: (context, event) => {
				return query.get("mock") !== "fail";
			},
		},
	};
	const [state, send, service] = useMachine(context, events);
	return [state, send, service];
};

export default useInterstitialMachine;
